module.exports = __webpack_public_path__ + "media/6.d87af0ad.mp3";